import { useNavigate } from 'react-router-dom';

const articleCards = [
  {
    slug: 'superbuy-spreadsheet-guide',
    title: 'Superbuy Sheet 2026: Complete Shopping Spreadsheet Guide',
    category: 'Guide',
    date: 'July 13, 2026',
    excerpt: 'Discover how Superbuy Sheet transforms your online shopping experience with organized product research, price comparisons, and category-specific spreadsheets. Our comprehensive 2026 guide covers everything from beginner basics to advanced strategies.',
    icon: '📊',
    accent: 'accent',
    featured: true,
  },
  {
    slug: 'what-is-superbuy-spreadsheet',
    title: 'What Is Superbuy Spreadsheet? Beginner Introduction',
    category: 'Tutorial',
    date: 'July 13, 2026',
    excerpt: 'New to Superbuy Spreadsheet? Learn the fundamentals of organized online shopping, how shopping spreadsheets work, who should use them, and how to set up your very first product research sheet.',
    icon: '🌱',
    accent: 'secondary',
    featured: false,
  },
  {
    slug: 'superbuy-spreadsheet-safety-guide',
    title: 'Is Superbuy Spreadsheet Safe? Security Guide',
    category: 'Safety',
    date: 'July 13, 2026',
    excerpt: 'Everything you need to know about staying safe while using shopping spreadsheets. Tips on link verification, avoiding scams, seller evaluation, privacy protection, and secure browsing practices.',
    icon: '🛡️',
    accent: 'accent',
    featured: false,
  },
];

export default function SeoArticles() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="mb-14">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-article-line"></i> SEO Resources
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-primary-800 leading-tight">
              Expert Guides &amp;
              <br />
              In-Depth Resources
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {articleCards.map((article) => {
              const isAccent = article.accent === 'accent';
              const accentBgClass = isAccent ? 'bg-accent-100' : 'bg-secondary-100';
              const accentTextClass = isAccent ? 'text-accent-600' : 'text-secondary-600';

              return (
                <article
                  key={article.slug}
                  className={`bg-background-50 rounded-2xl border border-background-200/60 p-6 hover:-translate-y-1 transition-all duration-300 cursor-pointer ${
                    article.featured ? 'md:col-span-2 lg:col-span-1' : ''
                  }`}
                  style={{ boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}
                  onClick={() => navigate(`/article/${article.slug}`)}
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div className={`w-12 h-12 rounded-xl ${accentBgClass} flex items-center justify-center flex-shrink-0`}>
                      <span className="text-xl">{article.icon}</span>
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-semibold text-primary-800 leading-snug mb-1">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500">
                        <span className={`${accentTextClass} font-medium`}>{article.category}</span> · {article.date}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-4">
                    {article.excerpt}
                  </p>
                  <div className={`mt-4 flex items-center gap-2 ${accentTextClass} text-sm font-medium cursor-pointer`}>
                    <span>Read More</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}